import { Typography } from 'antd';
import React from 'react';
import ActionParameterForm from './ActionParameterForm';

const { Text } = Typography;

function CallAction({ action, onFormsChange, disabled = false }) {
  return (
    <div>
      <Text strong className="block mb-2">
        Call Action
      </Text>

      {action.definition && action.definition.length > 0 && (
        <div className="bg-gray-50 rounded border border-gray-200 mt-2">
          <ActionParameterForm
            action={action}
            onFormsChange={onFormsChange}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

export default CallAction;
